<template>
    <div>
        <h4>Fórmulas de Sensores</h4>
        <hr />
        <h6>Legenda</h6>
        <div class="text-secondary font-weight-light">
            <ul class="list-unstyled">
                <li>
                    <strong>PIEZOMETER</strong> - Refere-se aos piezômetros.
                </li>
                <li>
                    <strong>WATER_LEVEL_MONITOR</strong> - Refere-se aos
                    medidores de vazão.
                </li>
                <li class="d-none">
                    <strong>DISPLACEMENT_TRANSDUCER</strong> - Refere-se aos
                    extensômetros de haste.
                </li>
                <li>
                    <strong>formula</strong> - Chave que define uma fórmula a
                    ser aplicada como resultado.
                </li>
                <li><strong>value</strong> - Representa o valor de leitura.</li>
            </ul>
        </div>
        <h6>Observações</h6>
        <div class="text-secondary font-weight-light">
            <ul class="list-unstyled">
                <li>Utilize parentêses para definir precedência na fórmula.</li>
                <li>
                    A unidade do valor de leitura corresponde a mesma exibida na
                    página de sensores.
                </li>
                <li>O operador de potenciação é o <strong>**</strong>.</li>
                <li>
                    Cada tipo de sensor pode ter a chave
                    <strong>formula</strong> e esta é utilizada caso o sensor
                    não possua uma fórmula específica definida pelo seu nome
                    dentro do tipo correspondente.
                </li>
            </ul>
        </div>
        <json-editor
            ref="jsonEditor"
            :json="formulas"
            :mode="mode"
            :disabled="updating"
        />
        <b-alert variant="danger" :show="errorMessage.length > 0">{{
            errorMessage
        }}</b-alert>
        <div class="d-flex justify-content-center">
            <b-button
                v-if="mode === 'read'"
                variant="secondary"
                class="d-flex align-items-center"
                @click="mode = 'edit'"
                ><i class="fas fa-pencil-alt mr-2" />Editar</b-button
            >
            <template v-else>
                <b-button
                    variant="secondary"
                    :disabled="updating"
                    class="d-flex align-items-center"
                    @click="updateFormulas"
                >
                    <template v-if="updating">
                        <b-spinner small class="mr-2" />Salvando...
                    </template>
                    <template v-else
                        ><i class="fas fa-save mr-2" />Salvar
                    </template>
                </b-button>
                <b-button
                    variant="danger"
                    class="d-flex align-items-center ml-2"
                    :disabled="updating"
                    @click="cancel"
                >
                    <i class="fas fa-times-circle mr-2" />Cancelar
                </b-button>
            </template>
        </div>
    </div>
</template>

<script>
import { default as http } from "@/modules/settings/api";
import sleep from "@/utils/sleep";
import JsonEditor from "./components/JsonEditor";

const api = http.formulas;

export default {
    name: "SensorFormulaManagement",
    components: {
        JsonEditor
    },
    props: {
        source: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            formulas: {},
            updating: false,
            errorMessage: "",
            mode: "read"
        };
    },
    async created() {
        const { data } = await api.getFormulas(this.source);
        this.formulas = data;
    },
    methods: {
        validate() {
            const jsonText = this.$refs.jsonEditor.getJsonText();
            const formulas = JSON.parse(jsonText);
            if (
                !formulas ||
                typeof formulas !== "object" ||
                Array.isArray(formulas)
            ) {
                throw new SyntaxError("JSON inválido.");
            }
            return formulas;
        },
        async updateFormulas() {
            this.errorMessage = "";
            this.updating = true;
            await sleep(500);

            try {
                const { data } = await api.updateFormulas(
                    this.source,
                    this.validate()
                );
                this.formulas = data;
                this.mode = "read";
                this.$bvToast.toast(
                    "Fórmulas de Sensores atualizadas com sucesso.",
                    {
                        title: "Aviso",
                        variant: "success",
                        noCloseButton: true
                    }
                );
            } catch (error) {
                if (error instanceof SyntaxError) {
                    this.errorMessage = "JSON de fórmulas: formato inválido.";
                } else if (error.response && error.response.status === 400) {
                    this.errorMessage = error.response.data.formulas;
                } else {
                    this.errorMessage =
                        "Ocorreu um erro no servidor, tente novamente mais tarde.";
                    console.error(error);
                }
            } finally {
                this.updating = false;
            }
        },
        cancel() {
            this.mode = "read";
            this.errorMessage = "";
        }
    }
};
</script>
